import filter from 'lodash.filter';
import find from 'lodash.find';
import forEach from 'lodash.foreach';
import * as Actions from '../map/actions';
import { lSportsConfig } from '../../config/lsports.config';
import * as Helper from './lsports.helper';

const initialState = {
    isLoaded: false,
    sports: null,
    locations: null,
    search: '',
    mainMarket: lSportsConfig.prematch.mainMarket,
    activeMatchId: -1,
    selectedSport: null,
    selectedLocation: null,
    selectedLeague: null,
    isLocationsActive: false,
    isPrematchActive: true,
    isLoadingStarted: false,
    desiredLoadCount: 0,
    loadedCount: 0,
    removeLeagueFromSportsCount: 0,
    isSportSearchActive: false,
    mainFilteredEvents: [],
    mainEvents: [],
};

const lSportsPrematchReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.ON_MAIN_MARKET_SELECTED: {
            let mainMarket = state.mainMarket;

            mainMarket = forEach(mainMarket, (m) => {
                if (m.Id === action.sportId) {
                    m.selectedMarket = action.marketId;
                }
            });

            return {
                ...state,
                mainMarket: mainMarket,
            };
        }

        case Actions.ON_SPORT_SELECTED: {
            let locations = state.locations;
            let sport = find(state.mainEvents, { Id: action.sportId });
            if (sport) {
                locations = sport.Locations;
            }

            return {
                ...state,
                selectedSport: action.sportId,
                locations: locations,
            };
        }

        case Actions.ON_LOCATION_SELECTED: {
            return {
                ...state,
                selectedLocation: action.locationId,
            };
        }

        case Actions.SET_LOCATIONS_ACTIVE: {
            return {
                ...state,
                isLocationsActive: action.value,
            };
        }

        case Actions.SET_PREMATCH_ACTIVE: {
            return {
                ...state,
                isPrematchActive: action.value,
            };
        }

        case Actions.ON_LEAGUE_SELECTED: {
            let { selectedSport, selectedLocation, mainEvents } = state;

            let mainFilteredEvents = Helper.filterEventsByLeague(selectedSport, selectedLocation, action.leagueId, mainEvents);
            return {
                ...state,
                selectedLeague: action.leagueId,
                mainFilteredEvents: mainFilteredEvents,
                search: '',
            };
        }

        case Actions.SET_ACTIVE_MATCH_ID: {
            return {
                ...state,
                activeMatchId: action.matchId,
            };
        }

        case Actions.SET_SPORT_SEARCH_ACTIVE: {
            return {
                ...state,
                isSportSearchActive: action.value,
            };
        }

        case Actions.ON_SEARCH: {
            let { mainEvents } = state;

            let events = Helper.ungroupEvents(mainEvents);
            events = Helper.searchEvents(events, action.search, false);
            events = Helper.groupEvents(events);

            return {
                ...state,
                search: action.search,
                mainFilteredEvents: events,
            };
        }

        case Actions.ON_CLEAR_SEARCH: {
            return {
                ...state,
                search: '',
                mainFilteredEvents: [],
            };
        }

        case Actions.START_LOADING: {
            return {
                ...state,
                isLoadingStarted: false,
                desiredLoadCount: action.desiredLoadCount,
                loadedCount: 0,
            };
        }

        case Actions.ON_REMOVE_LEAGUE: {
            let { mainFilteredEvents } = state;

            forEach(mainFilteredEvents, (e) => {
                if (e.Id === action.sportId) {
                    forEach(e.Locations, (location) => {
                        if (location.Id === action.locationId) {
                            location.Leagues = filter(location.Leagues, (league) => {
                                return league.Id !== action.leagueId;
                            });

                            e.Locations = filter(e.Locations, (location) => {
                                return location.Leagues.length !== 0;
                            });
                        }
                    });
                    mainFilteredEvents = filter(mainFilteredEvents, (g) => {
                        return g.Locations.length !== 0;
                    });
                }
            });

            //let removeLeagueFromSportsCount = state.isSportSearchActive ? state.removeLeagueFromSportsCount : state.removeLeagueFromSportsCount + 1;

            return {
                ...state,
                mainFilteredEvents: mainFilteredEvents,
                //removeLeagueFromSportsCount: removeLeagueFromSportsCount,
            };
        }

        case Actions.SET_PREMATCH_LEAGUE_EVENTS: {
            let events = action.events;
            let mainEvents = state.mainEvents;

            forEach(mainEvents, (sport) => {
                if (sport.Id === events.SportId) {
                    forEach(sport.Locations, (location) => {
                        if (location.Id === events.LocationId) {
                            forEach(location.Leagues, (league) => {
                                if (league.Id === events.LeagueId) {
                                    league.Events = [...league.Events, ...events.Events];
                                }
                            });
                        }
                    });
                }
            });

            return {
                ...state,
                mainEvents: mainEvents,
            };
        }

        case Actions.SET_PREMATCH_EVENTS: {
            let events = action.events;

            let locations = state.locations;
            if (state.selectedSport) {
                locations = find(events, { Id: state.selectedSport }).Locations;
            }

            return {
                ...state,
                mainEvents: events,
                locations: locations,
                isLoadingStarted: true,
                loadedCount: state.loadedCount + 1,
            };
        }

        case Actions.UPDATE_PREMATCH_RMQ_EVENT: {
            let event = action.event;
            if (event.Fixture === undefined || event.Fixture === null) {
                return state;
            }

            let mainEvents = state.mainEvents;

            let sport = find(mainEvents, { Id: event.Fixture.Sport.Id });
            let status = event.Fixture.Status;
            let ignoreAddingByStatus = !(status === 1 || status === 9);

            if (sport) {
                let location = find(sport.Locations, {
                    Id: event.Fixture.Location.Id,
                });

                if (location) {
                    let league = find(location.Leagues, {
                        Id: event.Fixture.League.Id,
                    });

                    if (league) {
                        let fixture = find(league.Events, {
                            FixtureId: event.FixtureId,
                        });

                        if (fixture) {
                            fixture.Fixture = event.Fixture;
                            fixture.Livescore = event.Livescore;
                            fixture.Markets = event.Markets;
                            //console.error(sport.Id, location.Id, league.Id, fixture.FixtureId, event);
                        } else if (!ignoreAddingByStatus) {
                            //Add fixture
                            league.Events = [...league.Events, event];
                        }
                    } else if (!ignoreAddingByStatus) {
                        //Add new league
                        location.Leagues = [
                            ...location.Leagues,
                            {
                                Id: event.Fixture.League.Id,
                                Name: event.Fixture.League.Name,
                                Count: 1,
                                Events: [event],
                            },
                        ];
                    }
                } else if (!ignoreAddingByStatus) {
                    //Add new location
                    sport.Locations = [
                        sport.Locations,
                        {
                            Id: event.Fixture.Location.Id,
                            Name: event.Fixture.Location.Name,
                            Count: 1,
                            Leagues: [
                                {
                                    Id: event.Fixture.League.Id,
                                    Name: event.Fixture.League.Name,
                                    Count: 1,
                                    Events: [event],
                                },
                            ],
                            Description: event.Fixture.Location.Name,
                            Sort: event.Fixture.Location.Id,
                        },
                    ];
                }
            } else if (!ignoreAddingByStatus) {
                //Add new sport
                mainEvents = [
                    ...mainEvents,
                    {
                        Id: event.Fixture.Sport.Id,
                        Name: event.Fixture.Sport.Name,
                        Count: 1,
                        EventCount: 1,
                        Locations: [
                            {
                                Id: event.Fixture.Location.Id,
                                Name: event.Fixture.Location.Name,
                                Count: 1,
                                Leagues: [
                                    {
                                        Id: event.Fixture.League.Id,
                                        Name: event.Fixture.League.Name,
                                        Count: 1,
                                        Events: [event],
                                    },
                                ],
                                Description: event.Fixture.Location.Name,
                                Sort: event.Fixture.Location.Id,
                            },
                        ],
                        Description: event.Fixture.Sport.Name,
                        Sort: event.Fixture.Sport.Id,
                        Icon: '',
                    },
                ];
            }

            return {
                ...state,
                mainEvents: mainEvents,
            };
        }

        default:
            return state;
    }
};

export default lSportsPrematchReducer;
